import type React from 'react';

import { type FocusableElement } from 'tabbable';

export function navigateNonTabbableElements({
  tabbableElms,
  recentSuggestionsRef,
  clearSuggestionsRef,
  searchSuggestionsRef,
  trendingSuggestionsRef,
  userSuggestionsRef,
}: {
  recentSuggestionsRef: React.RefObject<HTMLUListElement | null> | null;
  clearSuggestionsRef: React.RefObject<HTMLButtonElement | null> | null;
  searchSuggestionsRef: React.RefObject<HTMLUListElement | null> | null;
  trendingSuggestionsRef: React.RefObject<HTMLUListElement | null> | null;
  userSuggestionsRef: React.RefObject<HTMLUListElement | null> | null;
  tabbableElms: FocusableElement[];
}) {
  const recentSuggestionElems = recentSuggestionsRef?.current
    ? ([...recentSuggestionsRef.current.children].filter(
        (child) => child.tagName === 'LI'
      ) as FocusableElement[])
    : [];
  const searchSuggestionElems = searchSuggestionsRef?.current
    ? ([...searchSuggestionsRef.current.children].filter(
        (child) => child.tagName === 'LI'
      ) as FocusableElement[])
    : [];
  const trendingSuggestionElems = trendingSuggestionsRef?.current
    ? ([...trendingSuggestionsRef.current.children].filter(
        (child) => child.tagName === 'LI'
      ) as FocusableElement[])
    : [];
  const userSuggestionElems = userSuggestionsRef?.current
    ? ([...userSuggestionsRef.current.children].filter(
        (child) => child.tagName === 'LI'
      ) as FocusableElement[])
    : [];
  const clearSuggestionButton =
    (clearSuggestionsRef?.current as FocusableElement) || [];
  const suggestionElms: FocusableElement[] = [
    ...recentSuggestionElems,
    ...searchSuggestionElems,
    ...trendingSuggestionElems,
    ...userSuggestionElems,
  ];

  return {
    recentSuggestionElems,
    searchSuggestionElems,
    trendingSuggestionElems,
    userSuggestionElems,
    clearSuggestionButton,
    suggestionElms,
    tabbableElms,
  };
}
